import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TableColumn } from '../../models/table-column';
import {
  AuditStatus,
  PromotionStatus,
  AuditStatusColors,
  PromotionStatusColors,
  Promotion,
} from '../../../api/models/promotion';
import { DATETIME_WITHOUT_SECONDS } from '../../constants/date-formats';
import { TableCellColor } from '../../models/table-cell-color';
import { buildQueryParamsFromObject } from '../../../api/helpers/query-params-builder';
import { TableFilters } from '../table/table.component';
import { JointPromotion } from '../../../api/models/joint-promotion';

@Component({
  selector: 'app-promotions-table',
  templateUrl: './promotions-table.component.html',
  styleUrl: './promotions-table.component.scss',
  standalone: false,
})
export class PromotionsTableComponent implements OnInit {
  @Input() promotions: Promotion[] | JointPromotion[] = [];
  @Input() editColumn: TableColumn | undefined;
  @Input() hideAuditStatus : boolean = false;

  @Output() filtersChanged = new EventEmitter<string>();

  auditStatusList = this.getStatus(
    Object.values(AuditStatus),
    AuditStatusColors,
    'AUDIT_STATUS',
  );
  promotionsStatusList = this.getStatus(
    Object.values(PromotionStatus),
    PromotionStatusColors,
    'PROMOTION_STATUS',
  );

  promoColumns: TableColumn[] = [
    {
      type: 'text',
      label: 'DASHBOARD.PROMO-NAME',
      key: 'name',
      sortable: true,
      sortOptions: [{
        key: 'name',
        ascLabel: 'TABLE.SORTING.TEXT.ASC',
        descLabel: 'TABLE.SORTING.TEXT.DESC',
      }],
    },
    {
      type: 'text',
      label: 'DASHBOARD.PROMO-ID',
      key: 'id',
      sortable: true,
      sortOptions: [{
        key: 'id',
        ascLabel: 'TABLE.SORTING.TEXT.ASC',
        descLabel: 'TABLE.SORTING.TEXT.DESC',
      }],
    },
    {
      type: 'text',
      id: 'promoType',
      label: 'DASHBOARD.PROMO-TYPE',
      key: 'promotionMechanic.translationKey',
      sortable: true,
      sortOptions: [{
        key: 'promotionMechanic.translationKey',
        ascLabel: 'TABLE.SORTING.TEXT.ASC',
        descLabel: 'TABLE.SORTING.TEXT.DESC',
      }],
    },
    {
      type: 'enum',
      label: 'DASHBOARD.PROMO-STATUS',
      key: 'promotionStatus',
      values: this.promotionsStatusList,
      filterable: true,
      filterQueryParamName: 'promotionStatusList',
    },
    {
      type: 'enum',
      label: 'DASHBOARD.PROMO-AUDIT-STATUS',
      key: 'auditStatus',
      values: this.auditStatusList,
      filterable: true,
      filterQueryParamName: 'auditStatusList',
    },
    {
      type: 'date',
      label: 'DASHBOARD.PROMO-START-DATE',
      key: 'startDate',
      format: DATETIME_WITHOUT_SECONDS,
      sortable: true,
      sortOptions: [{
        key: 'startDate',
        ascLabel: 'TABLE.SORTING.DATE.ASC',
        descLabel: 'TABLE.SORTING.DATE.DESC',
      }],
      withoutTimezoneCorrection: false,
      customTimezone: 'timeZone'
    },
    {
      type: 'date',
      label: 'DASHBOARD.PROMO-END-DATE',
      key: 'endDate',
      format: DATETIME_WITHOUT_SECONDS,
      sortable: true,
      sortOptions: [{
        key: 'endDate',
        ascLabel: 'TABLE.SORTING.DATE.ASC',
        descLabel: 'TABLE.SORTING.DATE.DESC',
      }],
      withoutTimezoneCorrection: false,
      customTimezone: 'timeZone'
    },
  ];

  ngOnInit() {
    if (this.hideAuditStatus) {
      this.promoColumns = this.promoColumns.filter(column => column.key !== 'auditStatus');
    }
  }

  getColumns() {
    if (this.editColumn) {
      return [...this.promoColumns, this.editColumn];
    }
    return this.promoColumns;
  }

  getStatus(
    status: string[],
    colors: Record<string, TableCellColor>,
    statusKey: string,
  ): { key: string; value: string; color?: TableCellColor }[] {
    return status.map((key) => ({
      key,
      value: `${statusKey}.${key}`,
      color: colors[key],
    }));
  }

  onTableFiltersChanged(filters: TableFilters): void {
    this.filtersChanged.emit(buildQueryParamsFromObject(filters, true));
  }
}
